<section [ngClass]="{'pb-banner-image-background-grey pb-py-9 lg:pb-py-13' : rendering.fields?.BackgroundColor?.value == 'grey', 
            'pb-banner-image-background-warm-grey pb-py-9 lg:pb-py-13' : rendering.fields?.BackgroundColor?.value == 'warm-grey', 
            'pb-bg-inherit' : rendering.fields?.BackgroundColor?.value == ''}" class="pb-m-banner-image-list-gallery pb-border-none {{dynamicClass}}">
    <div *ngIf="rendering.fields?.Title?.value" class="pb-container pb-mb-10">
        <h2 class="pb-text-d-lg-m lg:pb-text-d-xl pb-mb-5 pb-font-serif pb-text-color-brand lg:pb-w-2/3" data-title="true" *scText="rendering.fields?.Title"></h2>
        <ng-container *ngIf="rendering.fields?.Subtitle?.value">
            <div class="pb-text-md-m lg:pb-text-lg lg:pb-pb-0 lg:pb-w-2/3" *scText="rendering.fields?.Subtitle"></div>
        </ng-container>
    </div>
    <div class="pb-space-y-11 lg:pb-space-y-13 pb-container" [ngClass]="containerClass">
        <ng-container *ngFor="let card of cards">
            <div app-banner-image-list [data]='card' [gallery]='true'></div>
        </ng-container>
    </div>
</section>
  